import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, AbstractControl, Validators, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[allowEmpty]',
  providers: [{ provide: NG_VALIDATORS, useExisting: EmptyEmailDirective, multi: true }]
})
export class EmptyEmailDirective {

  constructor() { }
  validate(control: AbstractControl): ValidationErrors  {

    if (!control.value) {
      return null;
    }
  
    return Validators.email(control);
  }
}



// WEBPACK FOOTER //
// ./src/app/directives/empty-email.directive.ts